export const navLinks = [
  { label: 'Thuisbatterijen', href: '/shop/home-batteries' },
  { label: 'Plug-in batterijen', href: '/shop/plug-in' },
  { label: 'Powerstations', href: '/shop/power-stations' },
  { label: 'Zonnepanelen', href: '/shop/solar-panels' },
  { label: 'Omvormers', href: '/shop/inverters' },
  { label: 'Accessoires', href: '/shop/accessories' },
];

export interface MegaLink {
  label: string;
  detail?: string;
  href: string;
}

export interface MegaMenuItem {
  id: string;
  label: string;
  href: string;
  featuredId: string;
  groups: { title: string; links: MegaLink[] }[];
}

export const megaMenu: MegaMenuItem[] = [
  {
    id: 'batteries',
    label: 'Thuisbatterijen',
    href: '/shop/home-batteries',
    featuredId: 'ampra-stack',
    groups: [
      {
        title: 'Kies je type',
        links: [
          { label: 'Vaste thuisbatterij', detail: 'Aangesloten door een installateur', href: '/shop/home-batteries' },
          { label: 'Plug-in batterij', detail: 'Zelf aansluiten op het stopcontact', href: '/shop/plug-in' },
          { label: 'Hybride omvormers', detail: 'Batterij-ready, 1- of 3-fase', href: '/shop/inverters' },
        ],
      },
      {
        title: 'Populaire merken',
        links: [
          { label: 'Ampra', href: '/shop/home-batteries' },
          { label: 'AlphaESS', href: '/shop/home-batteries' },
          { label: 'Huawei', href: '/shop/home-batteries' },
          { label: 'Zendure', href: '/shop/plug-in' },
          { label: 'Anker SOLIX', href: '/shop/plug-in' },
        ],
      },
    ],
  },
  {
    id: 'stations',
    label: 'Powerstations',
    href: '/shop/power-stations',
    featuredId: 'ecoflow-delta-3-plus',
    groups: [
      {
        title: 'Waarvoor',
        links: [
          { label: 'Kamperen & weekend weg', detail: 'Compact, onder 5 kg', href: '/shop/power-stations' },
          { label: 'Camper & boot', detail: '1–2 kWh, snel laden', href: '/shop/power-stations' },
          { label: 'Noodstroom thuis', detail: 'UPS-functie, uitbreidbaar', href: '/shop/power-stations' },
        ],
      },
      {
        title: 'Merken',
        links: [
          { label: 'EcoFlow', href: '/shop/power-stations' },
          { label: 'BLUETTI', href: '/shop/power-stations' },
          { label: 'Anker SOLIX', href: '/shop/power-stations' },
        ],
      },
    ],
  },
  {
    id: 'solar',
    label: 'Zonnepanelen',
    href: '/shop/solar-panels',
    featuredId: 'aiko-neostar-460',
    groups: [
      {
        title: 'Panelen',
        links: [
          { label: 'Full black panelen', detail: 'Strak op elk dak', href: '/shop/solar-panels' },
          { label: 'TOPCon panelen', detail: 'Beste prijs per watt', href: '/shop/solar-panels' },
          { label: 'Balkonsets', detail: 'Plug & play, met of zonder batterij', href: '/shop/plug-in' },
        ],
      },
      {
        title: 'Toebehoren',
        links: [
          { label: 'Omvormers', href: '/shop/inverters' },
          { label: 'Kabels & MC4', href: '/shop/accessories' },
        ],
      },
    ],
  },
  {
    id: 'accessories',
    label: 'Accessoires',
    href: '/shop/accessories',
    featuredId: 'homewizard-p1',
    groups: [
      {
        title: 'Categorie',
        links: [
          { label: 'Energiemeters', detail: 'Live verbruik & nul-op-de-meter', href: '/shop/accessories' },
          { label: 'Kabels & connectoren', detail: 'Voorgekrompen MC4', href: '/shop/accessories' },
        ],
      },
    ],
  },
];

export const brands = ['Ampra', 'EcoFlow', 'Anker SOLIX', 'Zendure', 'BLUETTI', 'AlphaESS', 'Victron Energy', 'Huawei'];

export const footerColumns = [
  {
    title: 'Assortiment',
    links: [
      { label: 'Thuisbatterijen', href: '/shop/home-batteries' },
      { label: 'Plug-in batterijen', href: '/shop/plug-in' },
      { label: 'Powerstations', href: '/shop/power-stations' },
      { label: 'Zonnepanelen', href: '/shop/solar-panels' },
      { label: 'Aanbiedingen', href: '/deals' },
    ],
  },
  {
    title: 'Klantenservice',
    links: [
      { label: 'Contact', href: '/' },
      { label: 'Verzending & levering', href: '/' },
      { label: 'Retourneren', href: '/' },
      { label: 'Garantie', href: '/' },
      { label: 'Veelgestelde vragen', href: '/' },
    ],
  },
  {
    title: 'Over ons',
    links: [
      { label: 'Over Ampra', href: '/' },
      { label: 'Showroom Utrecht', href: '/' },
      { label: 'Zakelijk', href: '/' },
      { label: 'Vacatures', href: '/' },
    ],
  },
];

export const paymentMethods = ['iDEAL', 'Klarna', 'Bancontact', 'PayPal', 'Visa', 'Mastercard'];
